import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: []
  }),
  getters: {
    list: state => state.list,
    flagMap: state => Object.freeze(state.list.reduce((map, auditRule) => auditRule.flags.reduce((map, flag) => {
      map[flag] = {
        id: auditRule.id,
        name: auditRule.name.replace(/规则$/, '')
      }
      return map
    }, map), {}))
  },
  mutations: {
    list (state, list) {
      state.list = Object.freeze(list)
    }
  },
  actions: {
    request ({commit}) {
      return Vue.prototype.$api.AuditRuleCategory.getList().then(auditRules => {
        commit('list', auditRules)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/AuditRule.js